(function () {
  'use strict';

  function easeOut(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function fmt(n, decimals) {
    var v = decimals ? n.toFixed(decimals) : String(Math.round(n));
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  class EbFactoryStory extends HTMLElement {
    connectedCallback() {
      this.counted = false;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.setupCounts();
      this.setupEmbed();
    }

    countUp(el) {
      var raw = el.getAttribute('data-count');
      var target = parseFloat(raw);
      if (isNaN(target)) return;
      var decimals = (String(raw).split('.')[1] || '').length;
      var dur = 1200;
      var start = null;

      function frame(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        el.textContent = fmt(easeOut(p) * target, decimals);
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    runCounts() {
      if (this.counted) return;
      this.counted = true;
      var self = this;
      this.querySelectorAll('[data-count]').forEach(function (el) {
        var raw = el.getAttribute('data-count');
        var target = parseFloat(raw);
        if (isNaN(target)) return;
        if (self.reduce) {
          var decimals = (String(raw).split('.')[1] || '').length;
          el.textContent = fmt(target, decimals);
        } else {
          self.countUp(el);
        }
      });
    }

    setupCounts() {
      if (!this.querySelector('[data-count]')) return;
      if ('IntersectionObserver' in window) {
        var self = this;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              self.runCounts();
              io.disconnect();
            }
          });
        }, { threshold: 0.3 });
        io.observe(this);
      } else {
        this.runCounts();
      }
    }

    setupEmbed() {
      var target = this.querySelector('[data-fs-embed-target]');
      var tpl = this.querySelector('[data-fs-embed]');
      if (!target || !tpl) return;

      var inject = function () {
        if (target.dataset.loaded === 'true') return;
        target.dataset.loaded = 'true';
        target.innerHTML = tpl.innerHTML;
        var frame = target.querySelector('iframe');
        if (frame) {
          frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
          frame.setAttribute('tabindex', '-1');
        }
      };

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              inject();
              io.disconnect();
            }
          });
        }, { rootMargin: '200px' });
        io.observe(this);
      } else {
        inject();
      }
    }
  }

  if (!customElements.get('eb-factory-story')) {
    customElements.define('eb-factory-story', EbFactoryStory);
  }
})();
